import script from "./CustomerCase.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerCase.vue?vue&type=script&setup=true&lang=js"

import "./CustomerCase.vue?vue&type=style&index=0&id=592b1336&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592b1336"]])

export default __exports__